import { type FC } from 'react';

import { type Document } from '@contentful/rich-text-types';
import type { ProductCardProps } from '@vakantiesnl/components/src/molecules/ProductCard/ProductCard';
import { ProductCardWrapper } from '@vakantiesnl/components/src/molecules/ProductCard/ProductCardWrapper';
import { ScrollableCardGroup } from '@vakantiesnl/components/src/molecules/ScrollableCardGroup';
import { type FilterState } from '@vakantiesnl/services/src/stores/filtersStore';
import { type GTM, type Search } from '@vakantiesnl/types';

import { useStyles } from './AccoCardsGroup.style';

export type AccoCardsGroupProps = {
	containerClassName?: string;
	heading: string;
	listDataCy?: string;
	document?: Document | null;
	accos: Search.CompactAccommodationItem[];
	accoItemDataCy?: string;
	accoCardSize?: ProductCardProps['size'];
	pageType?: GTM.GTMPageType;
	needQueryParams?: boolean;
	withScrollButtons?: boolean;
	needsDurationOverride?: boolean;
	headingClassName?: string;
	/** Filters to pass for adding filters to the url builder  */
	filters?: FilterState;
};

export const AccoCardsGroup: FC<AccoCardsGroupProps> = ({
	containerClassName,
	heading,
	document,
	listDataCy,
	accos,
	accoItemDataCy,
	accoCardSize,
	pageType,
	needQueryParams,
	withScrollButtons,
	needsDurationOverride,
	headingClassName,
	filters,
}) => {
	const { classes, cx } = useStyles();

	return (
		<ScrollableCardGroup
			containerClassName={containerClassName}
			listClassName={classes.accoCardsListContainer}
			headingClassName={headingClassName}
			heading={heading}
			document={document}
			listDataCy={listDataCy}
			withScrollButtons={withScrollButtons}
		>
			{accos.map((accommodation, index) => (
				<li
					className={cx(classes.accoItem, { [classes['micro']]: accoCardSize === 'micro' })}
					key={`${index}-${accommodation.name}`}
					data-cy={accoItemDataCy}
				>
					<ProductCardWrapper
						key={index}
						filters={filters}
						accommodation={accommodation}
						position={index + 1}
						size={accoCardSize}
						pageType={pageType}
						needQueryParams={needQueryParams}
						needsDurationOverride={needsDurationOverride}
					/>
				</li>
			))}
		</ScrollableCardGroup>
	);
};
